import { useServiceProvider } from '../Providers';
import React from 'react';

export function useCheckLocalStorageAvailability() {
  const { storageService, logger, getAuthService } = useServiceProvider();

  React.useEffect(() => {
    const isAvailable = storageService.checkLocalStorage();
    if (!isAvailable) {
      getAuthService().then(auth => {
        const currentUser = auth.currentUser;
        console.warn(`LocalStorage is not available for user ${currentUser?.id}`);
        logger.logMessage(`LocalStorage is not available for user ${currentUser?.id}`);
      });
    }
  }, [storageService, logger, getAuthService]);
}
